/**
 * AnswerCCReceiver ("Kopimodtager af epikrise", XREF01/XREF02): the unit gets a
 * copy of the epikrise, typically the patient's own GP. It must accept an
 * epikrise (DIS01 EDIFACT or XDIS01 XML), not a referral: a lægepraksis does
 * not receive XREF01/XREF02, so filtering on those hid every GP.
 */
export const EPIKRISE_RECEIVE_TYPES = ['DIS01', 'XDIS01'] as const;

export function receivesEpikrise(organisation: { ediReceiveTypes: readonly string[] | null | undefined }): boolean {
  const types = organisation.ediReceiveTypes ?? [];
  return EPIKRISE_RECEIVE_TYPES.some((type) => types.includes(type));
}
